import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getSize } from 'helpers/utils';

const FileUploader = ({
  file,
  initialFile,
  getRootProps,
  getInputProps,
  resetFile,
  isRemoved,
}) => {
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    if (!file) {
      setPreviewUrl(null);
      return;
    }

    const url = URL.createObjectURL(file);
    setPreviewUrl(url);

    return () => URL.revokeObjectURL(url);
  }, [file]);

  const renderContent = () => {
    if (file) {
      return (
        <div className="d-flex align-items-center py-3 px-3">
          <img
            src={previewUrl}
            alt={file.name}
            className="rounded"
            style={{ width: '100px', height: '100px', objectFit: 'contain' }}
          />
          <div className="ms-3 flex-grow-1">
            <div className="d-flex align-items-center justify-content-between">
              <h6 className="mb-0">{file.name}</h6>
              <button
                type="button"
                className="btn btn-link text-danger p-0"
                onClick={e => {
                  e.stopPropagation();
                  resetFile();
                }}
              >
                <FontAwesomeIcon icon="times" />
              </button>
            </div>
            <p className="mb-0 fs-10 text-500 text-start">
              {getSize(file.size)}
            </p>
          </div>
        </div>
      );
    }

    if (initialFile && !isRemoved) {
      return (
        <div className="d-flex align-items-center py-3 px-3">
          <img
            src={initialFile}
            alt="origin image"
            className="rounded"
            style={{ width: '100px', height: '100px', objectFit: 'contain' }}
          />
          <div className="ms-3 flex-grow-1 d-flex justify-content-end">
            <button
              type="button"
              className="btn btn-link text-danger p-0"
              onClick={e => {
                e.stopPropagation();
                resetFile();
              }}
            >
              <FontAwesomeIcon icon="times" />
            </button>
          </div>
        </div>
      );
    }

    return (
      <div className="d-flex justify-content-center align-items-center gap-2">
        <FontAwesomeIcon icon="file-upload" />
        <p className="fs-9 mb-0 text-700">Drop your file here</p>
      </div>
    );
  };

  return (
    <div
      {...getRootProps({
        className: `dropzone-area py-4 ${
          !file && !initialFile ? 'border-dashed' : ''
        }`,
      })}
    >
      <input {...getInputProps({ multiple: false })} />
      {renderContent()}
    </div>
  );
};

export default FileUploader;
